import { gql, useMutation } from "@apollo/client";

const CREATE_BEFORE_AND_AFTER = gql`
  mutation CreateBeforeAndAfterProject(
    $designerId: ID
    $name: String
    $description: String
    $style: ProjectStyles
    $projectCategory: ProjectCategory
    $specialRequirements: [SpecialRequirements]
    $budgetRange: BudgetRange
    $squareFootage: SquareFootage
    $projectDuration: ProjectDuration
    $beforeImage: ID
    $afterImage: ID
    $coverImage: ID
    $published: Boolean
    $storyTitle: String
    $storySubtitle: String
    $introduction: String
    $challenges: String
    $wishList: [String]
    $overview: String
    $additionalSections: [AdditionalSectionInput]
    $beforeImages: [ID]
    $afterImages: [ID]
  ) {
    createBeforeAndAfterProject(
      designerId: $designerId
      name: $name
      description: $description
      style: $style
      projectCategory: $projectCategory
      specialRequirements: $specialRequirements
      budgetRange: $budgetRange
      squareFootage: $squareFootage
      projectDuration: $projectDuration
      beforeImage: $beforeImage
      afterImage: $afterImage
      coverImage: $coverImage
      published: $published
      storyTitle: $storyTitle
      storySubtitle: $storySubtitle
      introduction: $introduction
      challenges: $challenges
      wishList: $wishList
      overview: $overview
      additionalSections: $additionalSections
      beforeImages: $beforeImages
      afterImages: $afterImages
    ) {
      _id
      designerId
      name
      description
      style
      projectCategory
      specialRequirements
      budgetRange
      squareFootage
      projectDuration
      beforeImage
      afterImage
      coverImage
      published
      storyTitle
      storySubtitle
      introduction
      challenges
      wishList
      overview
      additionalSections {
        title
        content
      }
      beforeImages
      afterImages
    }
  }
`;

export const useCreateBeforeAndAfterMutation = () => {
  const [createBeforeAndAfterMutation, { loading, error, data }] = useMutation(
    CREATE_BEFORE_AND_AFTER
  );

  const createBeforeAndAfter = async (args: any) => {
    try {
      const { data } = await createBeforeAndAfterMutation({
        variables: args,
      });
      return data?.createBeforeAndAfterProject;
    } catch (error) {
      console.error("Error creating before and after project:", error);
      throw error;
    }
  };

  return {
    createBeforeAndAfter,
    loading,
    error,
    data,
  };
};
